import React, { useState } from "react";
import { Hub } from "aws-amplify";
import { useReactiveVar } from "@apollo/client";
import { useNavigate, Outlet, Navigate } from "react-router-dom";
import {
  Box,
  Typography,
  AppBar,
  Button,
  Toolbar,
  Tabs,
  Tab,
  Stack,
} from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import icon from "../../assets/Henrick-logo.png";

import getTopNav from "../../function/getTopNav";
import { userVar, userEntityRelationVar } from "../../client/cache";

export default function ExternalPartnerLayout({ children }) {
  const user = useReactiveVar(userVar);

  if (user === "loading") return null;

  if (user?.sub) return <Navigate to="/cloud" replace />;

  return (
    <>
      <Navbar />
      <Box
        sx={{
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "space-between",
          mt: 5,
          height: "88vh",

          // border: 2,
          // borderColor: "secondary.main",
          // height: "110vh",
        }}
      >
        <Outlet />
      </Box>
    </>
  );
}

function Navbar() {
  let navigate = useNavigate();

  const nav = getTopNav({
    entityType: "ebp",
    userRole: "public",
    isAuthenticated: false,
  });

  const [value, setValue] = useState(false);

  // useEffect(() => {
  //   const menuMatched = nav.find(
  //     (x) => x.path === window.location.pathname.split("/")[1]
  //   );

  //   if (menuMatched) {
  //     setValue(menuMatched.label);
  //   } else {
  //     setValue(false);
  //   }
  // }, [navigate, nav]);

  return (
    <AppBar position="fixed" sx={{ opacity: 0.8 }}>
      <Toolbar>
        <Stack
          // sx={{ flexGrow: 1 }}
          direction="row"
          spacing={2}
          alignItems="center"
        >
          <img src={icon} alt="icon" width={20} height={24} />

          <Typography
            variant="h6"
            noWrap
            component="a"
            // href="/"
            onClick={() => {
              // setValue(false);
              navigate("/");
            }}
            sx={{
              mr: 2,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            HANKENO
          </Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }}>
          <Tabs
            value={value}
            onChange={(e, val) => {
              setValue(val);
            }}
            textColor="inherit"
            indicatorColor="secondary"
            // aria-label="secondary tabs example"
          >
            {nav.map((menu) => (
              <Tab
                key={menu.label}
                value={menu.label}
                label={menu.label}
                onClick={() => navigate(menu.path)}
                sx={{
                  visibility: menu.label === "Home" ? "hidden" : "visible",
                }}
              />
            ))}
          </Tabs>
          {/* <Divider /> */}
        </Box>

        {/* <Box sx={{ flexGrow: 1, ml: 5 }}>
          <Tabs
            // TabIndicatorProps={{
            //   style: {
            //     display: value === "Home" ? "none" : "block",
            //   },
            // }}
            value={value}
            onChange={(e, val) => {
              setValue(val);
            }}
            textColor="inherit"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            {nav.map((menu) => (
              <Tab
                key={menu.label}
                value={menu.label}
                label={menu.label}
                onClick={() => navigate(`/${menu.path}`)}
                sx={{
                  visibility: menu.label === "Home" ? "hidden" : "visible",
                }}
              />
            ))}
          </Tabs>
        </Box> */}
        <Box sx={{ flexGrow: 0 }}>
          <Button
            sx={{ color: "white" }}
            // href="/auth"
            onClick={() => {
              // navigate("auth");

              const vid = document.getElementById("video");

              vid && vid.pause();

              Hub.dispatch("dialogMonitor", {
                event: "auth",
                data: {},
                message: "",
              });
            }}
          >
            PORTAL
          </Button>
        </Box>
      </Toolbar>
      {/* <BreadcrumbsComp /> */}
    </AppBar>
  );
}
